import { render, staticRenderFns } from "./mentor.vue?vue&type=template&id=301ba404&scoped=true"
import script from "./mentor.vue?vue&type=script&lang=js"
export * from "./mentor.vue?vue&type=script&lang=js"
import style0 from "./mentor.vue?vue&type=style&index=0&id=301ba404&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301ba404",
  null
  
)

export default component.exports